import { Checkbox, Image } from "antd"
import { useState } from "react";
import { motion } from "framer-motion";
import { useExamStore } from "@store";

export const MultipleImageOption = () => {
  const currentQuestion = useExamStore((state) => state.clickedQuestion);

  const [checkedList, setCheckedList] = useState<any[]>();
  const onChange = (list: any[]) => {
    setCheckedList(list);
  };

    return (
      <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
        <Checkbox.Group value={checkedList} onChange={onChange} style={{ width: "100%", textAlign: "center", justifyContent: 'center' }} >
        {currentQuestion?.answers?.map((image, index) => (
          <Checkbox value={image.id} key={index} style={{ flexDirection: "column-reverse" }}>
            <div
              style={{ width: "200px" }}
              className={ checkedList?.includes(image.id) ? "custom-radio-btn-checked" : "custom-radio-btn"}
            >
              <Image preview={false} src={`data:image/${image.answerImageViewModel?.extension};base64,${image.answerImageViewModel?.base64Value}`} />
            </div>
          </Checkbox>
        ))}
      </Checkbox.Group>
      </motion.div>
       
    )
}